import {apiInstance} from "@/services/api";
import {ExcursionFilter, SmartFilterCondition} from "@/services/filters/types";

export async function index(): Promise<ExcursionFilter[]> {
    return (await apiInstance.get("/filters/")).data;
}

export function indexSmartFilter(sef: string): SmartFilterCondition[] {
    const match = sef.match(/filter\/(.+)\/apply/);

    if (match) {
        const out = [] as SmartFilterCondition[];
        const conditions = match[1].split("/");
        for (const condition of conditions) {
            const paths = condition.split('-');

            const is_numeric = paths[1] !== "is";
            let values = paths.filter((_v, index) => index > 1 && index % 2 == 0) as Array<string | number>;

            if (is_numeric) {
                values = values.map(item => +item);
            }

            if (is_numeric && paths[1] === 'to') {
                values = [0, values[0]];
            }

            out.push({
                name: paths[0],
                value: values
            });
        }

        return out;
    }

    return [];
}

export function buildSmartFilter(conditions: SmartFilterCondition[]) {
    return 'filter/' + conditions.map(condition=>{
        if(typeof condition.value[0] === 'string') {
            return `${condition.name}-is-${condition.value.join('-or-')}`
        }

        return `${condition.name}-to-${condition.value[1]}`
    }).join('/') + '/apply/'
}
